module.exports = __webpack_public_path__ + "static/media/for_professors.76c6aab9.png";